const ADMIN_ROLE = "admin";
const USER_ROLE = "user";
const WEGLOT_KEY = "wg_c0e869e958586a718205a184019383407";
const DEFAULT_LANGUAGE = "en";
const DEFAULT_ERROR_MSG = "Something went wrong !!!";

export { ADMIN_ROLE,USER_ROLE,WEGLOT_KEY,DEFAULT_LANGUAGE,DEFAULT_ERROR_MSG};
